let locale: LanguageKey = 'fr';

export const setLocale = (lang: LanguageKey) => locale = lang;

export const getLocale = () => locale;
